import type { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface TitledCardProps {
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
}

/** A card with a title and a one-line description above its content (the payables and Z-report pages). */
const TitledCard = ({ title, description, children }: TitledCardProps) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CardHeader>
    <CardContent>{children}</CardContent>
  </Card>
);

export default TitledCard;
